import { render, staticRenderFns } from "./EditOrganizationInterviewAttributes.vue?vue&type=template&id=90bba884&scoped=true"
import script from "./EditOrganizationInterviewAttributes.vue?vue&type=script&lang=js"
export * from "./EditOrganizationInterviewAttributes.vue?vue&type=script&lang=js"
import style0 from "./EditOrganizationInterviewAttributes.vue?vue&type=style&index=0&id=90bba884&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90bba884",
  null
  
)

export default component.exports